import {mapActions, mapGetters, mapMutations} from "vuex";
import Timer from "@/components/timer/index.vue";
import gallery from "./components/gallery-product/index.vue";
import promoItem from "./components/promo-item/index.vue";
import newItem from "./components/new-collection-item/index.vue";
import {VueSlideToggle} from "vue-slide-toggle";
import StarRating from "vue-star-rating";
import {maxLength, minLength, required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
import moment from "moment";
import VueAdsPagination, {VueAdsPageButton} from "vue-ads-pagination";
import crumbs from "./components/crumbs/index.vue";
import {dynamicHead} from "../../mixins/dynamic-head";

export default {
    name: "card",

    mixins: [validationMixin, dynamicHead],
    data() {
        return {
            addToFavorite: false,
            crumbs: [
                { title: "", name: "home", slug: "" },
                { title: this.$t("catalogProduct"), slug: "" },
            ],
            payload: {
                name: "",
                comment: "",
                rating: 0,
                product_id: null,
                date: null,
            },
            params: {
                title: "",
                description: "",
                keywords: "",
                name: "",
            },
            page: 0,
            validationErrors: {},
            openPromo: true,
            openNew: true,
            openFullDescription: false,
            openFullCharacteristic: false,
            openReviews: false,
            editCount: 1,
            disableAddButton: false,
            discount: false,
        };
    },
    mounted() {
        if (this.product) {
            this.product?.selected === 1 ? (this.addToFavorite = true) : (this.addToFavorite = false);
        }
    },

    validations() {
        return {
            payload: {
                name: {
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(20),
                },
                comment: {
                    required,
                    minLength: minLength(10),
                    maxLength: maxLength(100),
                },
            },
        };
    },
    components: {
        crumbs,
        gallery,
        VueSlideToggle,
        "promo-item": promoItem,
        "new-item": newItem,
        StarRating,
        VueAdsPagination,
        VueAdsPageButton,
        Timer,
    },
    watch: {
        "$route.path"() {
            this.resetProduct();
            this.fetchProduct({ slug: this.$route.params.item }).then(() => {
                this.setPageItem(this.product);
                this.fetchReviews({ id: this.product.id });
                this.fetchPromoList({ id: this.product.id });
                this.fetchNewCollectionList({ id: this.product.id });
                this.openFullDescription = false;
                this.openFullCharacteristic = false;
                this.openReviews = false;
                this.resetForm();
                this.crumbs = [{ title: "", name: "home", slug: "" }];
                this.generateBreadcrumbs();
            });
        },
    },
    computed: {
        ...mapGetters({
            promoList: "card/promoList",
            promoListLength: "card/promoListLength",
            promoListLoading: "card/promoListLoading",
            newCollectionList: "card/newCollectionList",
            newCollectionListLength: "card/newCollectionListLength",
            newCollectionListLoading: "card/newCollectionListLoading",
            product: "card/product",
            productLoading: "card/productLoading",
            basket: "basket/basket",
            countBasketItems: "basket/countBasketItems",
            reviewList: "card/reviewList",
            reviewListLength: "card/reviewListLength",
            reviewListLoading: "card/reviewListLoading",
            popupFastBuy: `card/popupFastBuy`,
            limit: "card/limit",
            isAuthenticated: "auth/isAuthenticated",
            popupRegister: "auth/popupRegister",
            sendReviewLoading: "card/sendReviewsLoading",
            filterCategories: "setting/filterCategories",
            favouriteList: "favorites/whichList",
            promocodeResponse: "card/promocodeResponse",
        }),
        getCurrentPrice() {
            if (this.product.sale_start) {
                let period = `${this.product.sale_start.slice(0, -8)},${this.product.sale_end.slice(0, -8)}`;
                let currentDate = new Date().toISOString().split("T")[0];
                let dates = period.split(",");
                let result = moment(currentDate).isBetween(dates[0], dates[1], null, "()");

                if (!result && this.product.discount_price === 0) {
                    return this.product.price;
                } else {
                    this.discount = true;
                    return this.product.discount_price;
                }
            } else {
                return this.product.price;
            }
        },
        async generateSchema() {
            let date = new Date();
            date.setDate(date.getDate() + 7);
            let nextWeekDate = date.toISOString().split('T')[0];

            const checkProduct = async () => {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        if (!this.product) {
                            reject(new Error("Product is null"));
                        } else {
                            resolve();
                        }
                    }, 200);
                });
            };

            while (true) {
                try {
                    await checkProduct();
                    break;
                } catch (error) {
                    console.log("Product is null, retrying...");
                }
            }

            let schema = {
                "@context": "https://schema.org/",
                "@type": "Product",
            };

            if (!!this.product?.title) {
                schema['name'] = this.product?.title;
            }

            if (!!this.product?.image) {
                schema['image'] = this.product?.image;
            }

            if (!!this.product?.description) {
                schema['description'] = this.product?.description_without_tags;
            }

            if (this.product?.attributes.find(item => item.attribute.slug === 'brend')) {
                schema['brand'] = {
                    '@type': "Brand",
                    'name': this.product?.attributes.find(item => item.attribute.slug === 'brend').value.title
                }
            }

            if (!!this.product?.code) {
                schema['sku'] = this.product?.code;
            }

            schema['offers'] = {
                "@type": "Offer",
                "url": window.location.href,
                "priceCurrency": "UAH",
                "price": this.product?.price,
                "priceValidUntil": nextWeekDate,
                "availability": "https://schema.org/InStock",
                "itemCondition": "https://schema.org/NewCondition"
            }

            schema['aggregateRating'] = {
                "@type": "AggregateRating",
                "ratingValue": this.product?.rating,
                "bestRating": "5",
                "worstRating": "1",
                "ratingCount": this.reviewListLength
            }
            if (this.reviewListLength === 0) {
                schema['aggregateRating'] = {
                    "@type": "AggregateRating",
                    "ratingValue": "5",
                    "bestRating": "5",
                    "worstRating": "1",
                    "ratingCount": "1"
                }
            }

            return schema;
        },
        getUnit() {
            if (this.product.unit !== null) {
                return "/" + this.product.unit;
            }
        },
        nameErrors() {
            let error = [];
            if (!this.$v.payload.name.$dirty) {
                return error;
            }
            if (!this.$v.payload.name.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (!this.$v.payload.name.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (this.validationErrors.name) {
                this.validationErrors.name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        commentErrors() {
            let error = [];
            if (!this.$v.payload.comment.$dirty) {
                return error;
            }
            if (!this.$v.payload.comment.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.comment.minLength) {
                error.push(this.$t("validationMin") + " 10");
            }
            if (!this.$v.payload.comment.maxLength) {
                error.push(this.$t("validationMax") + " 100");
            }
            if (this.validationErrors.comment) {
                this.validationErrors.comment.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        disableButton() {
            if (this.payload.name === "" || this.payload.comment === "") {
                return true;
            }
            return false;
        },
        replaceTags() {
            if (this.product.description !== null) {
                return this.product.description.replace(/(<([^>]+)>)/g, "");
            }
        },
    },
    created() {
        this.getPromocode();
        this.fetchProduct({ slug: this.$route.params.item }).then(() => {
            this.setPageItem(this.product);
            this.fetchReviews({ id: this.product.id });
            this.fetchPromoList({ id: this.product.id });
            this.fetchNewCollectionList({ id: this.product.id });

            this.generateBreadcrumbs();
        });
    },
    methods: {
        ...mapActions({
            getPromocode: "card/GET_PROMOCODE",
            fetchPromoList: `card/GET_PROMO_LIST`,
            fetchNewCollectionList: `card/GET_NEW_COLLECTION_LIST`,
            fetchProduct: `card/GET_PRODUCT`,
            fetchReviews: `card/GET_PRODUCT_REVIEWS`,
            sendReview: `card/SEND_REVIEW`,
            addFavourite: `favorites/ADD_PRODUCT_TO_FAVORITE`,
            fetchFavourite: `favorites/GET_FAVORITES_LIST`,
            addProductToBasket: `basket/ADD_PRODUCT_TO_BASKET`,
            removeFromFavourite: `favorites/REMOVE_PRODUCT_IN_FAVORITE`,
        }),
        ...mapMutations({
            resetBreadcrumbs: `system/RESET_CUSTOM_BREADCRUMBS_LIST`,
            addBasket: `basket/ADD_ITEM_TO_BASKET`,
            reset: `basket/RESET_AVAILABILITY_PROPS`,
            changeFastBuy: `card/CHANGE_POPUP_FAST_BUY`,
            changePage: `card/REVIEWS_CHANGE_PAGE`,
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
            resetProduct: `card/RESET_PRODUCT`,
        }),
        generateBreadcrumbs() {
            if (this.product.parents[0].parent) {
                this.crumbs.push({
                    name: "category-page",
                    title: this.product.parents[0].parent.title,
                    slug: this.product.parents[0].parent.slug,
                });
            }
            if (this.product.parents[0].slug) {
                this.crumbs.push({
                    name: "category-page",
                    title: this.product.parents[0].title,
                    slug: this.product.parents[0].slug,
                });
            }

            this.crumbs.push({
                name: "card",
                title: this.product.title,
                slug: this.product.slug,
            });
        },
        test() {
            this.$emit("");
        },
        addToBasket(product) {
            this.addBasket({
                min_price: this.product.min_price,
                select_count: this.editCount,
                select_price: product.discount_price ? product.discount_price : product.price,
                ...product,
            });
            this.$toasted.success(this.$t("successAddBasket"));
            this.editCount = 1;
        },
        decrementBasketItem() {
            this.editCount--;
        },
        incrementBasketItem() {
            this.editCount++;
        },
        // setCount() {
        //   // console.log(count);
        //     if (this.editCount > this.product.count) {
        //       this.editCount = this.product.count
        //     }
        // },
        setRating: function(rating) {
            this.payload.rating = rating;
        },
        resetForm() {
            this.$v.$reset();
            this.payload.name = "";
            this.payload.comment = "";
            this.payload.rating = 0;
            this.product_id = null;
            this.date = null;
        },
        changeRegister() {
            this.changePopupRegister({
                show: true,
                isRedirect: false,
            });
        },
        changePopup(status) {
            this.changeFastBuy({
                show: status,
                product_id: this.product.id,
                count: this.editCount,
            });
        },
        changePageLocal(page) {
            this.page = page;
            this.changePage(page + 1);
            let reviewObj = {};
            reviewObj.id = this.product.id;
            this.fetchReviews(reviewObj);
            this.$smoothScroll({
                scrollTo: this.$refs.reviews,
                duration: 500,
                offset: -60,
                updateHistory: false,
            });
        },
        changeWordMarks(count) {
            let titles = [this.$t("markWord1"), this.$t("markWord2"), this.$t("markWord3")];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[count % 100 > 4 && count % 100 < 20 ? 2 : cases[count % 10 < 5 ? count % 10 : 5]];
        },
        changeWordReviews(count) {
            let titles = [this.$t("reviewWord1"), this.$t("reviewWord2"), this.$t("reviewWord3")];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[count % 100 > 4 && count % 100 < 20 ? 2 : cases[count % 10 < 5 ? count % 10 : 5]];
        },
        addToFavourite(product) {
            if (this.isAuthenticated) {
                let currentProduct = this.favouriteList.find(favorite => favorite.id === product.id);
                if (currentProduct) {
                    return this.removeItem(currentProduct);
                }
                this.addFavourite(product)
                    .then(() => {
                        this.addToFavorite = true;
                        this.$toasted.success(this.$t("successAddFavourites"));
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status === 422) {
                            console.log(this.validationErrors);
                        }
                    });
            } else {
                this.changePopupRegister({ show: true, isRedirect: false });
            }
        },
        removeItem(product) {
            this.removeFromFavourite(product)
                .then(() => {
                    this.$toasted.success(this.$t("successRemoveFromFavourites"));
                    this.addToFavorite = false;
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 422) {
                        console.log(this.validationErrors);
                    }
                });
        },
        changeCountEvent(event) {
            let inputValue = parseInt(event.value);
            if (isNaN(inputValue)) inputValue = 1;

            if (this.product.count) {
                if (inputValue < 1) {
                    this.editCount = 1;
                }
                else if (inputValue > this.product.count) {
                    this.editCount = this.product.count;
                }
                else {
                    this.editCount = inputValue;
                }
                console.log(this.editCount);
                event.value = this.editCount;
                return;
            }
            this.editCount = inputValue;
        },
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.payload.product_id = this.product.id;
                this.payload.date = moment(new Date()).format("YYYY-MM-DD");
                let reviewObj = {};
                reviewObj.id = this.product.id;
                this.sendReview(this.payload)
                    .then(() => {
                        this.$toasted.success(this.$t("successAddReview"));
                        this.fetchReviews(reviewObj).then(() => {
                            this.resetForm();
                        });
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            Object.assign(this.validationErrors, error.response.data.errors);
                            console.log(this.validationErrors);
                            this.resetForm();
                        }
                    });
            }
        },
    },
    destroyed() {
        this.resetProduct();
    },
};
